import { render } from "./PublicHomeView.vue?vue&type=template&id=b94defd0&scoped=true"
import script from "./PublicHomeView.vue?vue&type=script&lang=js"
export * from "./PublicHomeView.vue?vue&type=script&lang=js"

import "./PublicHomeView.vue?vue&type=style&index=0&id=b94defd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94defd0"]])

export default __exports__